export type TargetType = {
  name: string,
  value: string
};

export const targetTypes = [
  {
    name: "Leaders",
    value: "L"
  },
  {
    name: "MIG Targets",
    value: "M"
  },
  {
    name: "Prospects",
    value: "P"
  },
  {
    name: "Targets",
    value: "T"
  },
  {
    name: "Lapsed Donors",
    value: "X"
  },
  {
    name: "Non-Leaders",
    value: "N"
  },
  {
    name: "No History",
    value: "A"
  }
];